import { render, staticRenderFns } from "./editHighlightResources.vue?vue&type=template&id=544c96e2&"
import script from "./editHighlightResources.vue?vue&type=script&lang=js&"
export * from "./editHighlightResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports